export default __webpack_public_path__ + "static/media/24.ca90ac98.png";